import {Component, OnInit, ViewChild} from '@angular/core';
import {BannerService} from "../../services/banner.service";
import {NgForm} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {UploadCropImagemComponent} from "../../superadmin/upload-crop-imagem/upload-crop-imagem.component";

@Component({
  selector: 'app-novo-banner',
  templateUrl: './novo-banner.component.html',
  styleUrls: ['./novo-banner.component.scss']
})
export class NovoBannerComponent implements OnInit {
  banner: any = {comando: 'NADA'};
  enviando = false;
  empresa: any;
  mensagemErro: string;
  @ViewChild('frm',  {static: false} ) frm: NgForm;

  readonly opcoesComando = [
    {valor: 'NADA', icone: 'fe-image', titulo: 'Só exibir', descricao: 'O banner é apenas visual'},
    {valor: 'LINK', icone: 'fe-external-link', titulo: 'Abrir um site', descricao: 'Instagram, formulário, página'},
    {valor: 'BUSCA', icone: 'fe-shopping-bag', titulo: 'Mostrar produtos', descricao: 'Cardápio filtrado por uma busca'}
  ];
  readonly teclaColar = /Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent || '') ? '⌘' : 'Ctrl';

  constructor(private bannerService: BannerService, private router: Router, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      if( params.id ) {
        this.bannerService.obtenhaBanner(params.id).then( (banner) => {
          this.banner = banner;
          if(this.banner.validade) this.banner.validade = new Date(this.banner.validade)

        });
      }
    });
  }

  cancelar() {
    this.router.navigateByUrl('/admin/loja/tab/banners').then( () => {
    });
  }

  onSalvar() {
    delete this.mensagemErro;
    if(!this.frm.valid){
      return;
    }

    if(!this.banner.linkImagem) {
      this.mensagemErro = 'Envie a imagem do banner antes de salvar.';
      return;
    }

    this.enviando = true;
    this.bannerService.salveBanner(this.banner).then( (resposta) => {
      this.enviando = false;

      this.router.navigateByUrl('/admin/loja/tab/banners').then( () => {
      });
    }).catch( erro => {
      this.mensagemErro = erro;
      this.enviando = false;
    });
  }

  salveFotoBanner($event: any) {
    $event.salvou();
  }

  // não usa o canceleImagem do upload: ele volta o campo para o backup, que é vazio quando nada foi cortado
  fecheEditor(upload: UploadCropImagemComponent) {
    upload.editarImagem = false;
    upload.imageChangedEvent = null;
    upload.showCropper = false;
  }

  testarBusca() {
    window.open('/loja/busca?q=' + encodeURIComponent(this.banner.extra));
  }

  testarEndereco() {
    window.open(this.banner.extra);
  }
}
